// Reserves the Edit link's slot instead of collapsing it (`display: none`, the shared
// `HoverMenuContainer`'s behaviour): `visibility` keeps the slot's width in the layout at all
// times, so it appearing on hover never re-wraps the codes and moves the one under the pointer.
// Scoped locally — `HoverMenuContainer` stays `display: none` for its other callers.
.editSlot {
  visibility: hidden;
}

.container:hover .editSlot {
  visibility: visible;
}

// Plain `flex-end` overflows toward the START side (left) when a single code is wider than its
// column, running it over the row's own label. `safe` (CSS Box Alignment Level 3) falls back to
// start-alignment once content overflows, so the excess spills right into the card's own padding
// instead — a code still never breaks mid-code, and never moves on hover (the `editSlot`
// reservation above is unaffected). Replaces `justify-content-end` outright since Bootstrap's
// utility carries `!important`.
.safeEnd {
  justify-content: safe flex-end;
}
